// src/components/pickers/RolePicker.tsx
import { useState } from 'react';
import { useCachedRoles } from './useGuildStructure';

interface RolePickerProps {
  guildId: string | null;
  value: string;
  onChange: (roleId: string) => void;
  placeholder?: string;
}

export function RolePicker({ guildId, value, onChange, placeholder }: RolePickerProps) {
  const { data: roles, isLoading } = useCachedRoles(guildId);
  const hasRoles = !!roles && roles.length > 0;

  const matchesCache = hasRoles && roles.some((r) => r.role_id === value);
  const [manualMode, setManualMode] = useState(!hasRoles || (!!value && !matchesCache));

  if (manualMode || !hasRoles) {
    return (
      <div className="channel-picker">
        <input
          className="input"
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value.trim())}
          placeholder={placeholder ?? 'Role ID'}
        />
        {hasRoles && (
          <button type="button" className="channel-picker__toggle" onClick={() => setManualMode(false)}>
            Choose from list instead
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="channel-picker">
      <select
        className="input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={isLoading}
      >
        <option value="">— Select a role —</option>
        {roles.map((r) => (
          <option key={r.role_id} value={r.role_id}>
            {r.role_name} ({r.role_id})
          </option>
        ))}
      </select>
      <button type="button" className="channel-picker__toggle" onClick={() => setManualMode(true)}>
        Enter ID manually instead
      </button>
    </div>
  );
}
